import { Pipe, PipeTransform } from '@angular/core'
@Pipe({
    name: 'PersonNamePipe',
    pure: true,
})
export class PersonNamePipe implements PipeTransform {
    transform(person: any): string {
        const name = (person?.firstName || '').trim() + ' ' + (person?.lastName || '').trim()
        return name.trim()
    }
}
